import React from 'react';
import { Tooltip } from 'antd';
import type { RealtimeSessionCounts } from './useRealtimeSessionCounts';

type Props = {
  data?: RealtimeSessionCounts;
  error: boolean;
};

export default function SessionCountsSummary({ data, error }: Props) {
  const metrics = [
    { label: 'sessions', value: data?.counts.sessions },
    { label: 'utilized', value: data?.counts.active },
    {
      label: 'online',
      value: data?.online_available ? data.counts.online : null,
    },
  ];
  const explanation = [
    'All playing or paused real-time sessions, across every page and regardless of table filters. Utilized counts players with trading or account activity. Online counts connected players per session.',
    error &&
      (data
        ? 'Refresh failed; showing previous totals.'
        : 'Totals unavailable; use Refresh counts to retry.'),
    data?.online_available === false && 'Online unavailable.',
    data && `Totals updated ${new Date(data.as_of).toLocaleString()}.`,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tooltip title={explanation} trigger={['hover', 'focus']}>
      <div
        role="group"
        aria-label="All active real-time sessions summary"
        tabIndex={0}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 10,
          padding: '3px 10px',
          border: '1px solid #e8e8e8',
          borderRadius: 6,
          background: '#fafafa',
          fontSize: 12,
          lineHeight: '20px',
          whiteSpace: 'nowrap',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        <span style={{ color: error ? '#ad6800' : '#8c8c8c', fontSize: 11 }}>
          All RT{error ? (data ? ' · stale' : ' · unavailable') : ''}
        </span>
        {metrics.map(({ label, value }) => (
          <span
            key={label}
            style={{
              display: 'inline-flex',
              alignItems: 'baseline',
              gap: 4,
              paddingLeft: 10,
              borderLeft: '1px solid #e8e8e8',
              color: '#595959',
            }}
          >
            <strong style={{ color: '#262626', fontSize: 14 }}>
              {value == null ? '—' : value.toLocaleString()}
            </strong>
            {label}
          </span>
        ))}
      </div>
    </Tooltip>
  );
}
